import React from 'react';

export default function AllFundTransactions({ transactions }) {
  return (
    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden border-b border-gray-200">
          {transactions.length > 0 ? (
            <table className={'min-w-full divide-y divide-gray-200'}>
              <tr className={'align-top'}>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  ID
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-center text-gray-700 font-medium tracking-wider'
                  }
                >
                  Status
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-center text-gray-700 font-medium tracking-wider'
                  }
                >
                  Currency Code
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Amount
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Transaction ID
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Created
                </th>
              </tr>
              <tbody>
                {transactions.map((item, index) => (
                  <tr
                    className={'border-b border-gray-200 align-top'}
                    key={index}
                  >
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {index + 1}
                    </td>
                    <td
                      className={
                        'text-center text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.status === 'successful' ? (
                        <span
                          className={
                            'py-1 px-2 text-sm rounded-md text-green-600 bg-green-100'
                          }
                        >
                          Successful
                        </span>
                      ) : item.status === 'pending' ? (
                        <span
                          className={
                            'py-1 px-2 text-sm rounded-md text-yellow-600 bg-yellow-100'
                          }
                        >
                          Pending
                        </span>
                      ) : item.status === 'failed' ? (
                        <span
                          className={
                            'py-1 px-2 text-sm rounded-md text-red-600 bg-red-100'
                          }
                        >
                          Failed
                        </span>
                      ) : null}
                    </td>
                    <td
                      className={
                        'text-center text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.currency}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.amount}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.tx_ref}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.created_at}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={'p-10 flex justify-center items-center'}>
              <h3>No transactions recorded</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
